// extracted by mini-css-extract-plugin
module.exports = {"star":"_118088","icon":"_3CkG9p","hovered":"_1A0OrX","active":"_37N402","black":"_1gGa56","red":"_2ZmZUQ","shine-lines":"_345t_l"};